import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import toast from 'react-hot-toast';
import config from '../../../../config';
// import { getItem } from '../../../utils/localStorageFn';
import getBrowserInfo from '../../../utils/getBrowserInfo';
import { editUser } from '../../../actions';
// import addLoginMethod from '../../../utils/addLoginMethod';
// import redirectByUrl from '../redirectByUrl';
// import createLoginKey from './createLoginKey';
import getDeviceType from '../../../utils/getDeviceType';
import {
  getAuthToken,
  getOrCreateDeviceIdentity,
  setAuthToken,
  setDeviceIdentity,
  setRefreshToken,
} from '../../../utils/auth';

// * Note - Completely random number
const toastId = 'JP238MD02';

const useGetOTP = () => {
  let device = {
    os: null,
    userAgent: null,
    browser: null,
    deviceKey: null,
    type: null,
  };

  if (window.navigator) {
    const { userAgent, platform } = window.navigator;
    device = {
      os: platform || 'unknown',
      userAgent,
      browser: getBrowserInfo(userAgent),
      type: getDeviceType(userAgent),
    };

    device.deviceKey = getOrCreateDeviceIdentity();
  }

  const handleGetOTP = ({ email, intentForOTP, showModal }) => {
    // addLoginMethod('fewcents');
    // const urlParams = getItem('url_params', 'json');

    // let device = {
    //   os: null,
    //   userAgent: null,
    //   browser: null,
    //   deviceKey: null,
    //   type: null,
    // };

    if (window.navigator) {
      const { userAgent, platform } = window.navigator;
      device = {
        os: platform || 'unknown',
        userAgent,
        browser: getBrowserInfo(userAgent),
        type: getDeviceType(userAgent),
      };

      device.deviceKey = getOrCreateDeviceIdentity();
    }

    (async () => {
      toast.loading('Sending One Time Password email...', { id: toastId });
      try {
        // const loginKeyDetailsData = await createLoginKey(urlParams);

        const payload = {
          ...device,
          email,
          role: 'member',
          refreshToken: '1234',
          password: 'test',
          name: 'test',
          idToken: '1234',
          accessToken: '1234',
          // currency: 'SGD',
          // loginType: 'fewcents',
          // ipAddress: '10.0.0.1',
          // loginKey: loginKeyDetailsData?.loginKey,
          // sourcePublisherId: loginKeyDetailsData?.loginPublisherId
          //  ? loginKeyDetailsData?.loginPublisherId : 0,
          // loginToken: loginKeyDetailsData?.loginKey,
          intentForOTP,
        };

        console.log('here');
        console.log(payload);
        console.log(JSON.stringify(payload));
        const response = await fetch(
          `${config.ApiBaseUrl}/user/getOneTimePassword`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          }
        );
        const json = await response.json();
        const { message, success } = json;

        if (!success)
          throw new Error(
            message ?? 'Something went wrong. failed to process request'
          );

        showModal(true);
        toast.success(
          'We have emailed your One Time Password (OTP). Please check your INBOX and SPAM folders.',
          {
            id: toastId,
            duration: 30000,
          }
        );
      } catch (e) {
        toast.error(e.message, {
          id: toastId,
        });
      }
    })();
  };

  return { handleGetOTP };
};

const useVerifyOTP = () => {
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  // const history = useHistory();
  let device = {
    os: null,
    userAgent: null,
    browser: null,
    deviceKey: null,
    type: null,
  };

  if (window.navigator) {
    const { userAgent, platform } = window.navigator;
    device = {
      os: platform || 'unknown',
      userAgent,
      browser: getBrowserInfo(userAgent),
      type: getDeviceType(userAgent),
    };

    device.deviceKey = getOrCreateDeviceIdentity();
  }

  const handleVerifyOTP = ({
    data,
    passwordFlow,
    setShowRegister,
    showModal,
  }) => {
    // addLoginMethod('fewcents');
    // const urlParams = getItem('url_params', 'json');

    console.trace(data);

    (async () => {
      try {
        toast.loading('Logging...', { id: toastId });
        // const loginKeyDetailsData = await createLoginKey(urlParams);

        const payload = {
          ...data,
          ...device,
          role: 'member',
          // currency: 'SGD',
          // loginType: 'fewcents',
          // ipAddress: '10.0.0.1',
          refreshToken: '1234',
          password: 'test',
          name: 'test',
          idToken: '1234',
          accessToken: '1234',
          // loginKey: loginKeyDetailsData?.loginKey,
          // sourcePublisherId: loginKeyDetailsData?.loginPublisherId
          //  ? loginKeyDetailsData?.loginPublisherId
          //  : 0,
          // loginToken: loginKeyDetailsData?.loginKey,
          intentForOTP: passwordFlow ? 'forgotPassword' : 'createUser',
        };

        const response = await fetch(
          `${config.ApiBaseUrl}/user/verifyOneTimePassword`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          }
        );
        const json = await response.json();
        const { message, success } = json;

        if (!success)
          throw new Error(
            message ?? 'Something went wrong. failed to process request'
          );

        const { user, accessToken, refreshToken, deviceKey } = json.data;

        if (!user) throw new Error('Error while signing up');

        dispatch(editUser(user));

        toast.dismiss();

        setAuthToken(accessToken);
        setRefreshToken(refreshToken);
        setDeviceIdentity(deviceKey);

        if (passwordFlow) {
          if (setShowRegister && showModal) {
            setShowRegister(true);
            showModal(false);
          }
        }
      } catch (e) {
        if (e.message.includes('incorrect')) setError('Incorrect OTP');
        toast.error(e.message ?? 'Failed to Change Password', { id: toastId });
      }
    })();
  };

  return { error, handleVerifyOTP };
};

const useManualSetPassword = () => {
  const history = useHistory();
  // const dispatch = useDispatch();
  const accessToken = getAuthToken();

  const setPassword = ({ password, email }) => {
    (async () => {
      const payload = {
        // customerId: customer.id,
        email,
        // homeCountry: data?.homeCountry ?? customer?.homeCountry,
        // homeCurrency: data?.homeCurrency ?? customer?.homeCurrency,
        password,
      };

      toast.loading('Updating password ...', { id: toastId });
      try {
        const response = await fetch(
          `${config.ApiBaseUrl}/user/setupPassword`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(payload),
          }
        );
        const json = await response.json();
        const { message, success } = json;

        if (!success)
          throw new Error(
            message ?? 'Something went wrong. failed to process request'
          );

        toast.success('Successfully updated', {
          id: toastId,
        });

        history.push('/content');
        //history.replace('/dashboard');
      } catch (e) {
        toast.error('Failed to update', { id: toastId });
      }
    })();
  };

  return setPassword;
};

export { useGetOTP, useVerifyOTP, useManualSetPassword };
